
import axios from "axios";
import environments from "../Utils/Environment";

const apiUrlStaging = environments.production.url;

const axiosInstance = axios.create({
  baseURL: apiUrlStaging,
});

// Request Interceptor - Add Token to Every Request
axiosInstance.interceptors.request.use(
  (config) => {
    config.headers = config.headers || {}; // Initialize if undefined
    const token = localStorage.getItem("accessToken");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    
    }
    return config;
  },
  (error) => Promise.reject(error)
);

axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status) {
      const { status } = error.response;
      console.error(`API Error [${status}]`, error.response.data);
      
      if ([401, 403].includes(status)) {
        console.warn("Auth failure - clearing tokens");
        localStorage.removeItem("accessToken");
        localStorage.removeItem("refreshToken");
        localStorage.removeItem("access_token");
        
        if (!window.location.pathname.includes("login")) {
          window.location.href = "/"; // Avoid loops
        }
      }
    } else {
      console.error("Network/Server Error:", error);
    }
    return Promise.reject(error);
  }
);


export default axiosInstance;
